module.exports = __webpack_public_path__ + "7e4b29ba/img/rename-icon.de4e673d.svg";